import { useRef as f, useLayoutEffect as i, useEffect as w } from "react";
import { a as u, o as c } from "./events-DamQnLE5.js";
const k = (s, m) => {
  const r = f(m || null), e = f(s);
  return i(() => {
    e.current = s;
  }), w(() => {
    const n = (o) => {
      var d;
      const t = r.current;
      t && !((d = t == null ? void 0 : t.contains) != null && d.call(t, o.target)) && e.current(o);
    }, a = (o) => {
      if (o.key === "Escape" || o.key === "Esc") {
        const t = new MouseEvent("mousedown", { bubbles: !0 });
        e.current(t);
      }
    };
    return u(document, "mousedown", n), u(document, "touchstart", n), u(document, "keydown", a), () => {
      c(document, "mousedown", n), c(document, "touchstart", n), c(document, "keydown", a);
    };
  }, []), r;
};
export {
  k as u
};
//# sourceMappingURL=useClickAway-B02nPhI9.js.map
